export const Logo = () => (
  <a
    href="#top"
    data-testid="nav-logo"
    onClick={(e) => {
      e.preventDefault();
      if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.4 });
      else window.scrollTo({ top: 0, behavior: "smooth" });
    }}
    className="inline-flex items-center"
    aria-label="Toro Finance Group — back to top"
  >
    <img
      src="/toro-logo-dark.png"
      alt="Toro Finance Group"
      className="h-11 w-auto sm:h-12"
    />
  </a>
);

export default Logo;
